import {mount} from 'svelte';

import InitializeLayout from '@js/layout';

import UserShow from '@js/components/user/UserShow.svelte';

InitializeLayout();

const userShowComponent = document.getElementById('user-show-component');
const userDataElement = document.getElementById('user-data');

if (!userShowComponent || ! userDataElement) {
    throw new Error('Components must be defined for User Show');
}

const defaultRideType = userShowComponent.getAttribute('data-default-ride-type');

const user = JSON.parse(userDataElement.innerText)?.user;
if (!user) {
    throw new Error('User data must be defined for User Show');
}

mount(UserShow, {
    target: userShowComponent,
    props: {
        user,
        defaultRideType
    }
});
